import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]

  showModal() {
    this.overlayTarget.classList.remove("hidden")
    this.menuTarget.classList.remove("hidden")
    // Use requestAnimationFrame to ensure the transition happens after display is set
    requestAnimationFrame(() => {
      this.overlayTarget.classList.add("opacity-100")
      this.menuTarget.classList.add("translate-x-0")
      this.menuTarget.classList.remove("-translate-x-full")
    })
  }

  closeModal() {
    this.overlayTarget.classList.remove("opacity-100")
    this.menuTarget.classList.remove("translate-x-0")
    this.menuTarget.classList.add("-translate-x-full")
    // Wait for transition to finish before hiding
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
      this.menuTarget.classList.add("hidden")
    }, 300)
  }

  closeOnClickOutside(event) {
    if (event.target === this.overlayTarget) {
      this.closeModal()
    }
  }
}
